<label class="mb-1">{{ title }}</label>
<span *ngIf="options === null" class="text-muted"><br> Loading...</span>
<ng-container *ngIf="options !== null">
  <ng-container *ngIf="options.length > 0">
    <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
            *ngIf="!allOptionsAreSelected()"
            (click)="setAllOptionsSelected()">
      Select All
    </button>
    <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
            *ngIf="allOptionsAreSelected()"
            (click)="setNoOptionsSelected()">
      Deselect All
    </button>
    <div class="form-check" *ngFor="let option of options">
      <input class="form-check-input" type="checkbox" id="optionCheckbox{{ option.id }}"
             [checked]="optionSelected(option)"
             (click)="toggleOption(option)">
      <label class="form-check-label" for="optionCheckbox{{ option.id }}">
        {{ option.name }}
      </label>
    </div>
  </ng-container>
  <ng-container *ngIf="options.length === 0">
    <span class="text-muted d-block">{{ optionsEmptyMessage }}</span>
  </ng-container>
</ng-container>
